<template>
  <div
    class="country-card card-condition connection-type"
    :class="{
      noteq: value === 'IS_NOT_MATCHING',
    }"
  >
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group
      style-type="inline"
      v-model="value"
      :label="t('Campaign and Visit Geo')"
      :label-help="t('This condition is necessary to manage random traffic from countries you don\'t buy traffic from, but still see it in the statistics.')"
    >
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="IS_MATCHING" :label="t('Is Matching')" />
        <ui-radio class="ml-16" value="IS_NOT_MATCHING" :label="t('Is Not Matching')" />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'visitCountryMatch',
  defaultValue: 'IS_NOT_MATCHING',
});
</script>
